<template>
  <!-- Global notification live region, render this permanently at the end of the document -->
  <div aria-live="assertive" class="z-20 fixed inset-0 flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start" v-if="alert && alert.message">
    <div class="w-full flex flex-col items-center space-y-4 sm:items-end">
      <!-- Notification panel, dynamically insert this into the live region when it needs to be displayed -->
      <transition enter-active-class="transform ease-out duration-300 transition" enter-from-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2" enter-to-class="translate-y-0 opacity-100 sm:translate-x-0" leave-active-class="transition ease-in duration-100" leave-from-class="opacity-100" leave-to-class="opacity-0">
        <div class="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 overflow-hidden">
          <div class="p-4">
            <div class="flex items-start">
              <div class="flex-shrink-0">
                  <ExclamationCircleIcon class="h-6 w-6 text-rose-400" aria-hidden="true" v-if="alertIcon == 'error'" />
                  <InformationCircleIcon class="h-6 w-6 text-cyan-400" aria-hidden="true" v-else-if="alertIcon == 'info'" />
                  <CheckCircleIcon class="h-6 w-6 text-green-400" aria-hidden="true" v-else />
              </div>
              <div class="ml-3 w-0 flex-1 pt-0.5">
                <p class="text-sm font-medium text-gray-900">
                 {{ alert.message }}
                </p>
                <a v-if="alert.button" :href="alert.button.href" class="block text-center mt-2 bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-uknar-primary">
                  {{alert.button.text}}
                </a>
              </div>
              <div class="ml-4 flex-shrink-0 flex">
                <button @click="hideAlert" class="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                  <span class="sr-only">Close</span>
                  <XIcon class="h-5 w-5" aria-hidden="true" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { CheckCircleIcon, InformationCircleIcon, ExclamationCircleIcon, XIcon } from '@heroicons/vue/outline'

export default {
    components: {
        CheckCircleIcon,
        InformationCircleIcon,
        ExclamationCircleIcon,
        XIcon,
    },

    watch: {
        success() {
            this.getAlertType()
        },

        error() {
            this.getAlertType()
        },

        info() {
            this.getAlertType()
        },

        customAlert() {
            this.getAlertType()
        }
    },

    props: {
      form_error: {
          type: String,
          required: true
      },
      success: {
          type: Object,
      },
      error: {
          type: Object,
      },
      info: {
          type: Object,
      },
      custom_alert: {
          type: [Array, String],
          default: null
      }
    },
    data: function () {
      return {
          alert: null,
          alertColor: 'green',
          alertIcon: 'success',
      }
    },
    methods: {
      getAlertType: function () {

          var self = this;

          if (self.form_error == 'true') {

              self.alert = {
                  'type': 'error',
                  'message': 'There are errors with the form you\'ve submitted! Please review the information'
              };
          }

          if (self.success && self.success.message) {
            self.alert = this.createAlertStructure('success', self.success);
          }

          if (self.error && self.error.message) {
            self.alert = this.createAlertStructure('error', self.error);

          }
          if (self.info && self.info.message) {
            self.alert = this.createAlertStructure('info', self.info);
          }

          if (self.custom_alert) {

              self.alert = {
                  'type': self.custom_alert['type'],
                  'message': self.custom_alert['message']
              };
          }

          if (self.alert) {
              self.setAlertType();
          }


      },

      createAlertStructure: function(type, input) {
        let obj = input;
        obj.type = type;
        return obj;
      },

      setAlertType: function () {
          var self = this;

          self.alertIcon = self.alert['type'];

          switch(self.alert['type']) {
              case 'error':
                self.alertColor = 'rose';
                break;
              case 'info':
                self.alertColor = 'cyan';
                break;
              default:
                self.alertColor = 'green';
          }
      },
      hideAlert: function () {
          this.alert = null;
          this.$emit('hide');
      }
    },
    mounted() {
      this.getAlertType();
    }
}
</script>
